var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { Subject, Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { EngineState } from 'src/app/engine/state/engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
export var TreeTheme;
(function (TreeTheme) {
    TreeTheme["Light"] = "light";
    TreeTheme["Dark"] = "dark";
    TreeTheme["Themed"] = "themed";
})(TreeTheme || (TreeTheme = {}));
var TreeComponent = /** @class */ (function () {
    function TreeComponent(store, graphService) {
        this.store = store;
        this.graphService = graphService;
        this.theme = TreeTheme.Dark;
        this.ngUnsubscribe = new Subject();
    }
    TreeComponent.prototype.ngOnInit = function () {
        var _this = this;
        // When the user selects a single structure, automatically scroll that structure into view
        // Note: as of 04/16/2019 this is only support by Chrome and Firefox
        this.store.select(EngineNodesState.getCheckedNodes)
            .pipe(filter(function (nodes) { return nodes.length === 1; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (node) {
            setTimeout(function () {
                _this.scrollNodeIntoView(node);
            });
        });
    };
    TreeComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    TreeComponent.prototype.scrollNodeIntoView = function (node) {
        var sanitizedID = this.graphService.sanitizeNodeID(node[0].id);
        var target = document.querySelector("[data-id=" + sanitizedID + "]");
        if (!target) {
            return;
        }
        // Manual check to see if the browser support smooth scrolling.
        // Although Safari supports scrollIntoView, it only has limited support via the boolean operator.
        // More importantly, the scrolled column jumps position when the mouse hovers over it.
        // For this reason we're not support Safari until Apple gets their act together.
        var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
        if (isSmoothScrollSupported) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    };
    __decorate([
        Select(EngineState.getViewGraph),
        __metadata("design:type", Observable)
    ], TreeComponent.prototype, "viewGraph$", void 0);
    return TreeComponent;
}());
export { TreeComponent };
